export default __webpack_public_path__ + "static/media/edit.94f60ea1.svg";